module.exports = __webpack_public_path__ + "static/img/Bachelor_010589.b0dc699.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010589.jpg
// module id = 195
// module chunks = 0